import { auth } from "../firebaseConfig";
import { API_BASE_URL } from "./apiBase";


export class OrganisationApiError extends Error {
  constructor(message, status = 0, code = "") {
    super(message);
    this.name = "OrganisationApiError";
    this.status = status;
    this.code = code;
  }
}

const postApi = async (path, body = {}) => {
  if (!auth.currentUser) {
    throw new OrganisationApiError("Please sign in again to manage organisations.", 401, "unauthenticated");
  }
  const token = await auth.currentUser.getIdToken();
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify(body),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.ok !== true) {
    throw new OrganisationApiError(
      data.error || "We could not complete that organisation action. Please try again.",
      response.status,
      data.code || ""
    );
  }
  return data;
};

const postOrganisation = (path, body) => postApi(`/api/organisations/${path}`, body);
const postLibrary = (path, body) => postApi(`/api/organisation-library/${path}`, body);

export const listMyOrganisations = () => postOrganisation("mine");
export const createOrganisation = (name) => postOrganisation("create", { name });
export const requestOrganisationJoin = (joinCode) => postOrganisation("join-requests/create", { joinCode });
export const listOrganisationMembers = (organisationId) => postOrganisation("members/list", { organisationId });
export const listPendingOrganisationRequests = (organisationId) => postOrganisation("join-requests/pending", { organisationId });
export const approveOrganisationRequest = (organisationId, requestId) =>
  postOrganisation("join-requests/approve", { organisationId, requestId });
export const declineOrganisationRequest = (organisationId, requestId) =>
  postOrganisation("join-requests/decline", { organisationId, requestId });
export const rotateOrganisationCode = (organisationId) => postOrganisation("rotate-code", { organisationId });
export const leaveOrganisation = (organisationId) => postOrganisation("leave", { organisationId });
export const removeOrganisationMember = (organisationId, userUid) =>
  postOrganisation("members/remove", { organisationId, userUid });

export const publishQuizToOrganisation = (organisationId, quizId) =>
  postLibrary("publish", { organisationId, quizId });
export const unpublishQuizFromOrganisation = (organisationId, quizId) =>
  postLibrary("unpublish", { organisationId, quizId });
export const listMyQuizPublications = () => postLibrary("mine");
export const listOrganisationLibrary = (organisationId) => postLibrary("list", { organisationId });
export const previewOrganisationQuiz = (organisationId, quizId) =>
  postLibrary("preview", { organisationId, quizId });
export const addOrganisationQuizToMine = (organisationId, quizId, requestId) =>
  postLibrary("add-to-my-quizzes", { organisationId, quizId, requestId });

export const loadOrganisationLibraryMedia = async (organisationId, quizId, blockId, revision) => {
  if (!auth.currentUser) {
    throw new OrganisationApiError("Please sign in again to preview this media.", 401, "unauthenticated");
  }
  const token = await auth.currentUser.getIdToken();
  const response = await fetch(`${API_BASE_URL}/api/organisation-library/media`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify({ organisationId, quizId, blockId, revision }),
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new OrganisationApiError(data.error || "Preview media is unavailable.", response.status, data.code || "");
  }
  return response.blob();
};
